import { render, staticRenderFns } from "./PieChartPHB2BB2C.vue?vue&type=template&id=6fa5843c&scoped=true&lang=pug&"
import script from "./PieChartPHB2BB2C.vue?vue&type=script&lang=ts&"
export * from "./PieChartPHB2BB2C.vue?vue&type=script&lang=ts&"
import style0 from "./PieChartPHB2BB2C.vue?vue&type=style&index=0&id=6fa5843c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5843c",
  null
  
)

export default component.exports